import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-too-short-meta-description',
    templateUrl: './too-short-meta-description.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoTooShortMetaDescriptionComponent {
}
